import React from 'react';

import styles from './CompanyBoxPlaceholder.module.scss';

const CompanyBoxPlaceholder = () => (
  <div className={styles.CompanyBoxPlaceholder}>
    <div className={styles.TextBlock} />
    <div className={styles.Image} />
    <div className={styles.LogoBox}>
      <div className={styles.Logo} />
      <div className={styles.LogoTextBlock} />
    </div>
  </div>
);

export default CompanyBoxPlaceholder;



// WEBPACK FOOTER //
// ./src/views/Companies/placeholder/CompanyBox/CompanyBoxPlaceholder.js